import React from 'react';
import PropTypes from 'prop-types';

const Help = ({ colour, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    {...props}>
    <path
      fill={colour}
      d="M7.677 2.18l.104 2.485a15.411 15.411 0 00-5.722 12c0 4.264 1.728 8.124 4.522 10.918 2.795 2.795 6.655-.624 10.919-.624s8.124 3.419 10.919.624a15.393 15.393 0 004.522-10.918c0-2.684-.684-5.208-1.889-7.406.329-.865.504-1.835.504-2.897v-.126A17.427 17.427 0 0135 16.665c0 9.665-7.835 17.5-17.5 17.5S0 26.33 0 16.665C0 10.64 3.044 5.328 7.677 2.179zm4.528 14.242c1.73 0 2.91 1.182 2.91 2.71 0 1.47-1.18 2.651-2.91 2.651-1.759 0-2.94-1.182-2.94-2.652 0-1.527 1.181-2.71 2.94-2.71zm8.794 0c1.729 0 2.91 1.182 2.91 2.71 0 1.47-1.181 2.651-2.91 2.651-1.759 0-2.94-1.182-2.94-2.652 0-1.527 1.181-2.71 2.94-2.71zM14.799.598l-.577 13.806h-4.18L9.467.598H14.8zM22.9.194c4.006 0 6.802 2.162 6.802 6.168 0 3.719-2.68 5.736-6.456 5.765l-.144 2.162h-4.324l-.144-5.361h1.73c2.709 0 4.582-.49 4.554-2.594 0-1.297-.808-2.104-2.076-2.104-1.412 0-2.19.864-2.19 2.19h-4.641C15.926 2.961 18.347.194 22.901.194z" // eslint-disable-line max-len
    ></path>
  </svg>
);

Help.propTypes = {
  colour: PropTypes.string.isRequired,
};

export default Help;
